import api from '@/store/api';
import { athena, boro } from '@/store/api/instances';
import type { CashService } from '@/types/configs';
import type { ApiListingRequest, ApiResponse } from '@bitstopco/bitstop-theme';

interface CreateCashServiceRequest {
  name: string;
  description: string;
}

interface UpdateCashServiceRequest {
  id: string;
  name: string;
  description: string;
  is_active?: boolean;
}

/**
 * RTK Query API for Cash Services.
 */
export const cashServicesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCashServices: build.query<ApiResponse<CashService[]>, ApiListingRequest | void>({
      query: (data) =>
        athena({
          url: 'v2/operations/cash-services',
          method: 'POST',
          data: data || {
            pagination: {
              current_page: 1,
              items_per_page: 1000,
              sort_by: 'name',
              sort_ascending: true,
            },
          },
        }),
      providesTags: ['CashServices'],
    }),
    createCashService: build.mutation<ApiResponse<CashService>, CreateCashServiceRequest>({
      query: (data) =>
        boro({
          url: 'v2/operations/cash-services',
          method: 'POST',
          data,
        }),
      invalidatesTags: ['CashServices'],
    }),
    updateCashService: build.mutation<ApiResponse<CashService>, UpdateCashServiceRequest>({
      query: ({ id, ...data }) =>
        boro({
          url: `v2/operations/cash-services/${id}`,
          method: 'PATCH',
          data,
        }),
      invalidatesTags: ['CashServices'],
    }),
    deleteCashService: build.mutation<void, string>({
      query: (id) =>
        boro({
          url: `v2/operations/cash-services/${id}`,
          method: 'DELETE',
        }),
      invalidatesTags: ['CashServices'],
    }),
  }),
});

export const {
  useGetCashServicesQuery,
  useCreateCashServiceMutation,
  useUpdateCashServiceMutation,
  useDeleteCashServiceMutation,
} = cashServicesApi;
